(() => {
  const PRODUCT_ROOT = '.shopify-section--main-product';
  const CTA_BACKORDER = /back\s*ordered[\s\S]*order\s*now/i;
  const CTA_PREORDER = /^(?:pre[\s-]?order(?:\s*now)?|précommander(?:\s+maintenant)?|reservar(?:\s+ahora)?)[.!]?$/i;
  const BADGE_TEXT = /^(?:pre[\s-]?order|back\s*ordered|backorder(?:ed)?)(?:\s*[·|:\-]\s*.*)?[.!]?$/i;

  const clean = value => (value || '').replace(/\s+/g, ' ').trim();

  function setClickableText(el, text) {
    if (el instanceof HTMLInputElement) {
      el.value = text;
      return;
    }

    const label = el.querySelector('[class*="label" i], span:not(:has(svg))');
    if (label && clean(label.textContent).length) label.textContent = text;
    else el.textContent = text;
  }

  function markCtas(root) {
    let hasPreorder = false;

    root.querySelectorAll('button, a, [role="button"], input[type="submit"]').forEach(el => {
      const text = clean(el instanceof HTMLInputElement ? el.value : el.textContent);
      if (!text) return;

      if (CTA_BACKORDER.test(text)) {
        hasPreorder = true;
        el.classList.add('vc-preorder-cta');
        if (text.toUpperCase() !== 'PRE-ORDER NOW') setClickableText(el, 'PRE-ORDER NOW');
      } else if (CTA_PREORDER.test(text)) {
        hasPreorder = true;
        el.classList.add('vc-preorder-cta');
      }
    });

    root.classList.toggle('vc-preorder-active', hasPreorder);
  }

  function markOriginalBadgeText(root) {
    const gallery = root.querySelector('.product-gallery') || root;
    const walker = document.createTreeWalker(gallery, NodeFilter.SHOW_TEXT);
    let node;

    while ((node = walker.nextNode())) {
      const text = clean(node.nodeValue);
      if (!text || text.length > 48 || !BADGE_TEXT.test(text)) continue;

      const parent = node.parentElement;
      if (!parent || parent.closest('button, a, [role="button"]')) continue;
      parent.classList.add('vc-preorder-badge');
    }
  }

  function scan() {
    const root = document.querySelector(PRODUCT_ROOT);
    if (!root) return;
    markCtas(root);
    markOriginalBadgeText(root);
  }

  let queued = false;
  const queueScan = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();

  new MutationObserver(queueScan).observe(document.documentElement, {
    childList:true,
    subtree:true,
    characterData:true
  });
})();

